
import { EMPTY_INTERFACE_MONITORING_ENTITY, InterfaceMonitoringEntity } from "domain/entity/InterfaceMonitoring/InterfaceMonitoringEntity";
import { EMPTY_INTERFACE_MONITORING_SEARCH_CRITERIA, InterfaceMonitoringSearchCriteria } from "domain/entity/InterfaceMonitoring/InterfaceMonitoringSearchCriteria";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface BankInterfaceMonitoringDropdownOptions {
    messageTypeDropdownOptions: DropdownProps[],
    formDropdownOptions: DropdownProps[],
    toDropdownOptions: DropdownProps[],
    statusDropdownOptions: DropdownProps[],
}
export interface BankInterfaceMonitoringChangeState extends BaseViewChangeSate {
}

export interface BankInterfaceMonitoringMaintenanceModel {
    isLoading: boolean,
    isShowRightPanel: boolean,
    isShowSearchPanel: boolean,
    searchCriteria: InterfaceMonitoringSearchCriteria
    dynamicOptions: BankInterfaceMonitoringDropdownOptions,
    isShowDetail: boolean,
    viewState: BankInterfaceMonitoringChangeState,
    currentBankInterfaceMonitoringEty: InterfaceMonitoringEntity,
    selectedBankInterfaceMonitoringRows: InterfaceMonitoringEntity[],
    bankInterfaceMonitoringEtys: InterfaceMonitoringEntity[],
    isBackFromDetail: boolean,
    isSearchLoading: boolean,
}

export const EMPTY_BANK_INTERFACE_MONITORINGANY_MODEL: BankInterfaceMonitoringMaintenanceModel = {
    isLoading: false,
    isShowRightPanel: false,
    isShowSearchPanel: false,
    searchCriteria: EMPTY_INTERFACE_MONITORING_SEARCH_CRITERIA,
    dynamicOptions: {
        messageTypeDropdownOptions: [],
        formDropdownOptions: [],
        toDropdownOptions: [],
        statusDropdownOptions: [],
    },
    isShowDetail: false,
    viewState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: true,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        },
    },
    currentBankInterfaceMonitoringEty: { ...EMPTY_INTERFACE_MONITORING_ENTITY },
    selectedBankInterfaceMonitoringRows: [],
    bankInterfaceMonitoringEtys: [],
    isBackFromDetail: false,
    isSearchLoading: true,
}